import { useMemo, useState } from "react";
import { CalendarDays } from "lucide-react";
import BirthDatePickerModal from "./BirthDatePickerModal";

function localISO(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function todayLocalISO() {
  return localISO(new Date());
}

function futureLimitISO() {
  const limit = new Date();
  limit.setFullYear(limit.getFullYear() + 100);
  return localISO(limit);
}

export function formatDatePickerLabel(value) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value || ""));
  if (!match) return "Select date";
  return new Intl.DateTimeFormat("en-PH", { year: "numeric", month: "short", day: "numeric" })
    .format(new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3])));
}

export default function DatePickerInput({
  value,
  onValueChange,
  min,
  max,
  className = "",
  placeholder = "Select date",
  title = "SELECT DATE",
  submitLabel = "APPLY DATE",
  ariaLabel,
  disabled = false,
  required = false,
  name,
}) {
  const [open, setOpen] = useState(false);
  const resolvedMax = max || futureLimitISO();
  const defaultValue = useMemo(() => {
    const today = todayLocalISO();
    if (min && today < min) return min;
    if (resolvedMax && today > resolvedMax) return resolvedMax;
    return today;
  }, [min, resolvedMax]);

  return (
    <>
      <button
        type="button"
        name={name}
        disabled={disabled}
        aria-label={`${ariaLabel || title.toLowerCase()}${required ? " (required)" : ""}`}
        aria-haspopup="dialog"
        aria-expanded={open}
        onClick={() => setOpen(true)}
        className={`${className} flex items-center justify-between gap-3 text-left disabled:cursor-not-allowed disabled:opacity-60`}
      >
        <span className={value ? "text-inherit" : "text-neutral-400"}>{value ? formatDatePickerLabel(value) : placeholder}</span>
        <CalendarDays className="h-4 w-4 shrink-0 text-neutral-400" aria-hidden="true" />
      </button>
      <BirthDatePickerModal
        open={open}
        value={value}
        minDate={min || "1900-01-01"}
        maxDate={resolvedMax}
        defaultValue={defaultValue}
        title={title}
        submitLabel={submitLabel}
        wheelLabel="Date"
        closeLabel="Close date picker"
        onClose={() => setOpen(false)}
        onConfirm={(nextValue) => {
          onValueChange(nextValue);
          setOpen(false);
        }}
      />
    </>
  );
}
